import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MetaService} from '../../../services/meta/meta.service';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {CefrlExamService} from '../../../services/cefrl-exam/cefrl-exam.service';
import {AudioService} from '../../../services/audio/audio.service';
import {SpinnerComponent} from '../../../components/spinner/spinner.component';
import {ProgressCircleComponent} from '../../../components/progress/progress-circle/progress-circle.component';

@Component({
  selector: 'app-cefrl-exam-result',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    SpinnerComponent,
    ProgressCircleComponent
  ],
  templateUrl: './cefrl-exam-result.component.html',
  styleUrls: ['./cefrl-exam-result.component.scss']
})
export class CefrlExamResultComponent implements OnInit {

  loading = true;
  result: any;
  // Skip du parcours : uniquement dans le state de navigation en fin de tentative
  // (absent de GET /result → false sur un rechargement de la page, c'est voulu)
  unlockedLevels = false;

  constructor(
    private metaSrv: MetaService,
    private translate: TranslateService,
    public langSrcSrv: LangSrcService,
    private router: Router,
    private route: ActivatedRoute,
    private cefrlExamSrv: CefrlExamService,
    public audioSrv: AudioService
  ) {
    this.unlockedLevels = this.router.getCurrentNavigation()?.extras?.state?.unlockedLevels === true;
  }

  trackByIndex(index: number) { return index; }

  async ngOnInit() {
    this.translate.get(`Résultat de l'examen`).subscribe((value: string) => {
      this.metaSrv.setMetas({title: value});
    });
    this.result = await this.cefrlExamSrv.result(this.route.snapshot.params.idSection);
    // Aucune tentative terminée : retour à l'écran d'accueil de l'examen
    if (!this.result) {
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'cefrl-exam', this.route.snapshot.params.idSection]);
      return;
    }
    this.loading = false;
  }

  async close() {
    await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'games']);
  }

  // Prochaine étape du parcours (exposée par l'API dans result.nextStep)
  get hasNextStep(): boolean {
    return !!this.result?.nextStep && this.result.nextStep.unlocked !== false;
  }

  async goToNextStep() {
    const lang = this.langSrcSrv.current.shortCode;
    const next = this.result?.nextStep;
    if (!next) {
      await this.router.navigate(['/', lang, 'games']);
      return;
    }
    if (next.type === 'exam') {
      await this.router.navigate(['/', lang, 'cefrl-exam', next.uniqid]);
      return;
    }
    await this.router.navigate(['/', lang, 'games', next.uniqid]);
  }

  answerGiven(question: any): string | null {
    return question.freeText || question.answerGiven || null;
  }

}
